<template>
  <div class="manuals">
    <div class="wrapper">
    <div class="manual-heading">
      <h2>{{ trans.text['manuals'].title }}</h2>
    </div>
    <div class="manual-content">
      <div v-for="model in models" :key="model.id" class="manual-item">
        <div v-if="model['manuals'].length > 0">
          <div class="model-title">{{ model.model }}</div>
          <ul class="model-manuals">
            <li v-for="manual in model['manuals']" :key="manual.id" class="model-manual-item">
              <a :href="manual.path" target="_blank">{{ manual.name }}</a>
            </li>
          </ul>
        </div>
      </div>
    </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ['lang', 'trans', 'models'],
  name: "ManualsComponent",
  data() {
    return {}
  },
  methods: {
    baseName(str) {
      return String(str).substring(str.lastIndexOf('/') + 1);
    }
  }
}
</script>

<style lang="scss" scoped>
.manuals {
  width: 100%;
  margin-left: auto;
  margin-right: auto;
  padding: 65px 0 0;

  .manual-heading {
    h2 {
      font-family: Object Sans, serif;
      font-style: normal;
      font-weight: bold;
      font-size: 36px;
      line-height: 37px;
      color: #000000;
      text-align: center;
      margin: 0 0 90px;
    }
  }

  .manual-content {
    .model-title {
      font-family: Object Sans, serif;
      font-style: normal;
      font-weight: bold;
      font-size: 24px;
      line-height: 34px;
      color: #000000;
    }

    .model-manuals {
      list-style-position: outside;
      list-style-type: none;
      padding-left: 22px;
      margin-bottom: 38px;

      .model-manual-item {
        a {
          font-family: Object Sans, serif;
          font-style: normal;
          font-weight: normal;
          font-size: 17px;
          line-height: 25px;
          text-decoration-line: underline;
          color: #2F80ED !important;

          &:hover {
            text-decoration: none;
          }
        }
      }
    }
  }
  @media(max-width: 767px) {
    .manual-heading {
      h2 {
        font-size: 20px;
        line-height: 30px;
        margin: 0 0 40px;
      }
    }
    .manual-content {
      .model-title {
        font-size: 20px;
        line-height: 30px;
        margin-bottom: 4px;
      }
      .model-manuals {
        padding-left: 28px;
        margin-bottom: 24px;
      }
    }
  }
}
</style>
